import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';
import { ProjectSocAutomationProvider } from '@views/SocAutomation/context/ProjectSocAutomationProvider';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/idnp-automations')({
  beforeLoad: () => getTitleContextSlice('Automations'),
  staticData: {
    owner: CodeOwner.IDNP,
  },
  component: () => (
    <ProjectSocAutomationProvider soarApp="platform" entityScope={['USER', 'IDENTITY_FINDING', 'ALERT', 'INCIDENT']}>
      <Outlet />
    </ProjectSocAutomationProvider>
  ),
});
